import React from 'react';

const PaymentScreen = () => {
  return <div>PaymentScreen</div>;
};

export default PaymentScreen;
